export default "__VITE_ASSET__41284b99__"